import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        copyWrapper: {
            padding: '50px 24px'
        },
        gridContainerCentre: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            justifyContent: 'center',
            minHeight: '100vh',
            [theme.breakpoints.down('md')]: {
                minHeight: 'auto',
            }
        },
        header: {
            alignItems: 'center',
            display: 'flex',
            marginBottom: theme.spacing(4),
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                justifyContent: 'center',
            }
        },
        illustrationImage: {
            height: '171px',
            width: '208.86px'
        },
        registrationRoot: {
            display: 'inline-flex'
        },
        returnButton: {
            '&.MuiButton-contained': {
                '&:focus': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                '&:hover': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                alignItems: 'center',
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                color: '#003168',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 0,
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                justifyContent: 'center',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                order: 2,
                textTransform: 'uppercase'
            }
        },
        title: {
            color: colors[mode].errorTitle,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '-0.5px',
            lineHeight: 'var(--4, 32px)',
            marginBottom: '28px'
        },
        verbiage: {
            color: colors[mode].errorVerbiage,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '20px',
            whiteSpace: 'pre-line'
        },
        verbiageHelpText: {
            color: colors[mode].errorVerbiage,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '20px'
        }
    }
}

export default styles